import request from "root/js/request";

export const getAnalyticsCrossMPSubjects = async ({ cabinet_id, name, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/subjects/",
    method: "get",
    params: {
      cabinet_id,
      name,
      ...rest,
    },
  });
  return response.data;
};
